import * as React from "react";
import EdButton from "../../../../generic/edButton";
import ObEqDtlContent from "../dsk/obEqDtlContent";
import Tab from "../../../../generic/tab";
import ObAssetsDetlSymMob from "../../instruments/details/obAssetsDetlSymMob";
import { ObAssetsDetlSymProps } from "./../../instruments/details/obAssetsDetlSym";
import moment from "moment";
import { dateTimeFormat } from "./../../../../service/dateTimeService";
import { ChipStatusComb } from "./../../obConstants";
import { AEqGetTradeBk } from "../../../../service/orderBook/obApiService";
import DeviceContext from "../../../../service/indentifyDevice";
import ObAssetDetailPopup from "../../generic/obAssetDetailPopup";
import ObEquityConvertMob from "../../obConvertPositions/obEquityConvertMob";
import ObTradeTabContent from "../../obConvertPositions/obTradeTabContent";
import { backButtonValue } from "./../../obJsXConstants";
import { IListObj } from "../../../../types/genericTypes";
import "../../../../../assets/scss/components/toc/orderBook/obDetails/obAssetDetailsMob.scss";

export interface ObEqDtlsOpenMobProps {
	data: any;
	onBackClick: (event: React.MouseEvent<HTMLButtonElement>) => void; // the function to be called onClick
	isTodayOrder: boolean;
	onCancelClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export interface ObEqDtlsOpenMobState {
	selectedTab: string | number;
	tradeData: Array<any>;
	showTradePopup: boolean;
	tabLst: Array<IListObj>;
}

class ObEqDtlsOpenMob extends React.Component<ObEqDtlsOpenMobProps, ObEqDtlsOpenMobState> {
	state = { selectedTab: "info", tradeData: [], showTradePopup: false, tabLst: [{ value: "info", display: "Info" }] };

	assetDetail: ObAssetsDetlSymProps = {
		date: this.props.data.rcvEpTim
			? moment(dateTimeFormat(this.props.data.rcvEpTim)).format("D MMM YYYY, HH:mm:ss")
			: moment(dateTimeFormat(this.props.data.ordEntTyp)).format("D MMM YYYY, HH:mm:ss"),
		trsTyp: this.props.data.trsTyp,
		title: this.props.data.trdSym,
		subTitle: this.props.data.cpName ? this.props.data.cpName : this.props.data.dpName ? this.props.data.dpName : this.props.data.symName,
		sts: this.props.data.sts ? ChipStatusComb[this.props.data.sts.toLowerCase()] : ""
	};

	tabLstSelect = (id: string | number) => {
		this.setState({ selectedTab: id });
	};

	eqGetTradeBkRes = (res: any) => {
		if (res.data) {
			this.setState({
				tradeData: res.data.trade,
				tabLst: [
					{ value: "info", display: "Info" },
					{ value: "trade", display: "Trades" }
				]
			});
		}
	};

	componentDidMount() {
		AEqGetTradeBk(this.eqGetTradeBkRes, this.props.data.ordID);
	}

	render() {
		return (
			<div>
				<section className="ob_detail_container">
					<section className="ob_detail_wrapper">
						<section className="ob_mob ly_mob ">
							<div className="ob_title ly_title  bckBtnDiv">
								{/* back button */}
								<EdButton value={backButtonValue} btnTyp="link" onClick={this.props.onBackClick} className="icon_button" />
							</div>
							<div className="lv_header">
								<ObAssetsDetlSymMob {...this.assetDetail} />
								{/* convert trade button for mobile */}
								<div className="convert_trde_btn_mob">
									{this.state.tradeData.length > 0 && DeviceContext().isMobile && (
										// button to convert positions
										<EdButton value="Convert" btnTyp="primary" onClick={() => this.setState({ showTradePopup: true })} slim />
									)}
								</div>
								{/* when status is rejected will show below content */}
								{this.props.data.rjRsn && (
									<div className="rjct_reason">
										<p className="rsn_hd">Reason</p>
										<p className="rsn">{this.props.data.rjRsn}</p>
									</div>
								)}
							</div>

							<div className="ob_content_mob ly_content_mob ">
								<Tab defaultValue={this.state.selectedTab} tabList={this.state.tabLst} onSelect={this.tabLstSelect} position="left" />
								{/* detailed content */}
								<div className={"info" + (this.state.selectedTab === "info" ? " show" : " hide")}>
									<ObEqDtlContent
										data={this.props.data}
										isTodayOrder={this.props.isTodayOrder}
										showTradeTab={this.state.tradeData.length > 0}
										tradeData={this.state.tradeData}
										onCancelClick={this.props.onCancelClick}
									/>
								</div>
								{/* if the tab is trade then show trade content below */}
								<div className={"trade" + (this.state.selectedTab === "trade" ? " show" : " hide")}>
									<div className="mg-t20 mg-b20">
										<div className="mg-t20 mg-b20 trad_desk_wrap">
											<ul className="ob_conver_tbl">
												{this.state.tradeData.map((data, index) => (
													<ObTradeTabContent key={index} showCheckbox={false} data={data} />
												))}
											</ul>
											{!DeviceContext().isMobile && (
												<div className="convrt_btn_con">
													<EdButton
														value="Convert Positions"
														btnTyp="primary"
														onClick={() => {
															this.setState({ showTradePopup: true });
														}}
														slim
													/>
												</div>
											)}
										</div>
									</div>
								</div>
							</div>
						</section>
					</section>
				</section>
				{this.state.showTradePopup && (
					<ObAssetDetailPopup>
						<ObEquityConvertMob data={this.state.tradeData} onBackClick={() => this.setState({ showTradePopup: false })} />
					</ObAssetDetailPopup>
				)}
			</div>
		);
	}
}

export default ObEqDtlsOpenMob;
